import React, { FC, useEffect, useMemo, useState } from 'react';
import { ReactComponent as ArrowLeft } from 'images/icons/arrow-left.svg';

import { updateInterceptionNetworkById } from '../../api/interception';
import { USER_NAME_LIMIT } from '../../constants/profile';
import { useAppSelector } from '../../hooks';
import { InterceptionNetwork } from '../../interfaces/interceptions';
import {
  interceptionDepartmentsSelector,
  interceptionsSelector,
} from '../../store/slices/interception/selectors';
import { Select, TextInput } from '../ui';
import EntityFieldsGroup from '../ui/EntityCard/EntityFieldsGroup';

export interface InterceptionsNetworkInfoSidebarProps {
  network: InterceptionNetwork;
  closeSidebar: () => void;
}

const InterceptionsNetworkInfoSidebar: FC<
  InterceptionsNetworkInfoSidebarProps
> = ({ network, closeSidebar }) => {
  const { name, id, frequency, department_id } = network;
  const [selectedParamsTab, setSelectedParamsTab] = useState(true);
  const [title, setTitle] = useState('');
  const [department, setDepartment] = useState<string | null>(null);
  const interceptions = useAppSelector(interceptionsSelector);
  const departments = useAppSelector(interceptionDepartmentsSelector);
  const departmentOptions = useMemo(() => {
    return departments.map((department) => ({
      label: department.name,
      value: department.id,
    }));
  }, [departments]);

  const networkInterceptions = useMemo(() => {
    return interceptions.filter(
      (interception) => interception.network_id === id
    );
  }, [interceptions, id]);

  useEffect(() => {
    const foundDepartment = departments.find(
      (department) => department.id.toString() === department_id?.toString()
    );
    setDepartment(foundDepartment?.id || null);
  }, [departments, department_id]);

  const handleDepartmentChange = async (value: string | null) => {
    setDepartment(value);

    if (value) {
      await updateInterceptionNetworkById({
        id,
        department_id: value,
      });
    }
  };

  const handleTitleSubmit = async () => {
    await updateInterceptionNetworkById({
      id,
      name: title,
    });
  };

  return (
    <div
      className={`absolute w-[520px] right-0 !h-[calc(100vh-100px)] bg-dark rounded-[10px] overflow-auto mr-1.5`}
    >
      {/*<div className="header__links">*/}
      {/*  <div className="flex flex-row w-full">*/}
      {/*    <div*/}
      {/*      className={cn(*/}
      {/*        'flex gap-1 items-center w-full justify-center',*/}
      {/*        {*/}
      {/*          'header-link__active': !selectedParamsTab,*/}
      {/*          'bg-light': selectedParamsTab,*/}
      {/*        },*/}
      {/*        'py-2 px-6'*/}
      {/*      )}*/}
      {/*      onClick={() => setSelectedParamsTab(false)}*/}
      {/*    >*/}
      {/*      <p className="header-link__title tpg-b1">Активность</p>*/}
      {/*    </div>*/}
      {/*    <div*/}
      {/*      className={cn(*/}
      {/*        'flex gap-1 items-center w-full justify-center',*/}
      {/*        {*/}
      {/*          'header-link__active': selectedParamsTab,*/}
      {/*          'bg-light': !selectedParamsTab,*/}
      {/*        },*/}
      {/*        'py-2 px-6'*/}
      {/*      )}*/}
      {/*      onClick={() => setSelectedParamsTab(true)}*/}
      {/*    >*/}
      {/*      <p className="header-link__title tpg-b1">Параметры</p>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {selectedParamsTab ? (
        <div className="p-6 h-full">
          <EntityFieldsGroup title="Основная информация">
            <div className="mt-2 border border-1 border-solid border-bright_product rounded-[10px] flex flex-col">
              <div className="flex flex-col px-4 py-2 border-b border-solid border-b-bright_product">
                {name ? (
                  <>
                    <div className="text-[11px] tpg-c2 text-tpg_light">
                      Название
                    </div>
                    <div className="text-tpg_base">{name}</div>
                  </>
                ) : (
                  <TextInput
                    value={title}
                    maxLength={USER_NAME_LIMIT}
                    labelText="Название"
                    placeholder="Дайте свое название сети"
                    onChange={(username) => setTitle(username)}
                    classNames={{ container: 'w-full' }}
                    onBlur={handleTitleSubmit}
                  />
                )}
              </div>
              <div className="flex flex-col px-4 py-2 border-b border-solid border-b-bright_product">
                <div className="text-[11px] tpg-c2 text-tpg_light">
                  Передача
                </div>
                <div className="text-tpg_base">Digital Mobile Radio</div>
              </div>
              <div className="flex flex-col px-4 py-2 border-b border-1 border-solid border-b-bright_product">
                <div className="text-[11px] tpg-c2 text-tpg_light">
                  Частота, МГЦ
                </div>
                <div className="text-tpg_base">{frequency}</div>
              </div>
              <div className="flex flex-col px-4 py-2 border-b border-solid border-b-bright_product">
                <div className="text-[11px] tpg-c2 text-tpg_light">
                  Подразделение
                </div>
                <div className="entity-card-select">
                  <Select
                    placeholder="Выберите подразделение"
                    options={departmentOptions}
                    value={department}
                    onSelect={(value) => handleDepartmentChange(value)}
                    withEmpty={false}
                    theme="dark"
                  />
                </div>
              </div>
              <div className="flex flex-col px-4 py-2">
                <div className="text-[11px] tpg-c2 text-tpg_light">
                  Абоненты сети
                </div>
                <div className="text-tpg_base">PEGAS-OP2/Auto</div>
              </div>
            </div>
          </EntityFieldsGroup>
          <div className="mt-4">
            <EntityFieldsGroup title="Расположение">
              {networkInterceptions.map((interception) => (
                <div
                  key={interception.id}
                  className="mt-4 border border-1 border-solid border-bright_product rounded-[10px] flex flex-col"
                >
                  <div className="flex flex-col px-4 py-2 border-b border-solid border-b-bright_product">
                    <div className="text-[11px] tpg-c2 text-tpg_light">WGS</div>
                    <div className="text-tpg_base">{interception.place}</div>
                  </div>
                  <div className="flex flex-col px-4 py-2 border-b border-solid border-b-bright_product">
                    <div className="text-[11px] tpg-c2 text-tpg_light">
                      СК-42
                    </div>
                    <div className="text-tpg_base">{interception.place}</div>
                  </div>
                  <div className="flex flex-col px-4 py-2 border-b border-solid border-b-bright_product">
                    <div className="text-[11px] tpg-c2 text-tpg_light">
                      Азимут
                    </div>
                    <div className="text-tpg_base">{interception.azimuth}</div>
                  </div>
                  <div className="flex flex-col px-4 py-2">
                    <div className="text-[11px] tpg-c2 text-tpg_light">
                      Угол
                    </div>
                    <div className="text-tpg_base">{interception.angle}</div>
                  </div>
                </div>
              ))}
            </EntityFieldsGroup>
          </div>
        </div>
      ) : null}
      <div
        className="fixed w-full bottom-0 z-[1] bg-light py-[6px] px-4 tpg-c2 text-tpg_base cursor-pointer flex items-center"
        onClick={closeSidebar}
      >
        <ArrowLeft className="fill-current text-white" />
        <div className="relavite top-[1px]">Назад</div>
      </div>
    </div>
  );
};

export default InterceptionsNetworkInfoSidebar;
